import ArticleSearchTagsDeleteBtn from './components/ArticleSearchTagsDeleteBtn'
import ArticleSearchTagsCreateBtn from './components/ArticleSearchTagsCreateBtn'
import { IFaqArticleSearchTag } from '../../../../../../faq.types'

interface IProps {
  selected: IFaqArticleSearchTag[]
}

const ArticleSearchTagsHeader = (props: IProps) => {
  return (
    <div className='flex-space-between'>
      <h2 className='page--header'>Поисковые теги</h2>
      <div className='inline-flex-gap'>
        <ArticleSearchTagsDeleteBtn selected={props.selected} />
        <ArticleSearchTagsCreateBtn />
      </div>
    </div>
  )
}

export default ArticleSearchTagsHeader
